var documentAll = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll == 'undefined' && documentAll !== undefined;

module.exports = {
  all: documentAll,
  IS_HTMLDDA: IS_HTMLDDA
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/node_modules/core-js-pure/internals/document-all.js
// module id = h9Fl
// module chunks = 0